import React from 'react';
import FormatItalicIcon from '@material-ui/icons/FormatItalic';
import MarkButton from './MarkButton';

function ItalicButton() {
  return <MarkButton format="italic" Icon={<FormatItalicIcon fontSize="small" />} />;
}

export default ItalicButton;
